import { createSelector } from 'reselect'
import getPaymentScheduleRequestInfo from './getPaymentScheduleRequestInfo'
import { getPaymentScheduleKey } from 'lib/payment/paymentScheduleUtils'

const getCurrentPaymentSchedule = createSelector(
  (state: App.State) => state.paymentSchedule,
  getPaymentScheduleRequestInfo,
  (paymentSchedule, paymentScheduleRequestInfo): App.PaymentScheduleChargeData | undefined => {
    const key = getPaymentScheduleKey(paymentScheduleRequestInfo)

    // Check if the key exists in charges before accessing it
    if (key && paymentSchedule.charges && key in paymentSchedule.charges) {
      return paymentSchedule.charges[key]
    }

    return undefined
  },
)

export default getCurrentPaymentSchedule
